/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-indent */
import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './index.css';
import { BsGithub } from 'react-icons/bs';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { projectsData } from '../data';

const Portfolio = () => {
  const [selectedProject, setSelectedProject] = useState(null);

  return (
    <section className="container" id="portfolio">
      <h5>My Work</h5>

      <div className="container portfolio_container">
        {/* Projects Section */}
        <div className="projects">
          <h3>Projects</h3>
          <div className="projects_list">
            {projectsData.map((project) => (
              <motion.div
                key={project.id}
                layoutId={project.id}
                onClick={() => setSelectedProject(project)}
                className="project_card"
              >
                <img src={project.demoImage} alt={project.name} />
                <div className="project_info">
                  <h4>{project.name}</h4>
                  <p>{project.description}</p>
                  <div className="project_links">
                    <a href={project.githubLink} target="_blank" rel="noopener noreferrer">
                      GitHub
                      {' '}
                      <BsGithub className="i" />
                    </a>
                    <a href={project.liveDemoLink} target="_blank" rel="noopener noreferrer">
                      Live Demo
                      {' '}
                      <FaExternalLinkAlt className="i" />
                    </a>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      {/* Detailed Project View */}
       <AnimatePresence>
        {selectedProject && (
          <motion.div
            key={selectedProject.id}
            layoutId={selectedProject.id}
            exit={{ opacity: 0, scale: 0 }}
            className="detailed-project-modal"
            onClick={() => setSelectedProject(null)}
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
          >
            <div className="detailed-project-content">
              <img src={selectedProject.demoImage} alt={selectedProject.name} />
              <div className="detailed-project-info">
                <h4>{selectedProject.name}</h4>
                <p>{selectedProject.description}</p>
                <div className="project_links">
                  <a href={selectedProject.githubLink} target="_blank" rel="noopener noreferrer">
                    GitHub
                      {' '}
                      <BsGithub className="i" />
                  </a>
                  <a href={selectedProject.liveDemoLink} target="_blank" rel="noopener noreferrer">
                    Live Demo
                      {' '}
                      <FaExternalLinkAlt className="i" />
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        )}
       </AnimatePresence>
    </section>
  );
};

export default Portfolio;
